import http from 'plugins/axios';

export default {
  getCoinList(data) {
    return http.post({
      url: '/admin/voteCoin/list',
      data
    });
  },
  createCoin(data) {
    return http.post({
      url: '/admin/voteCoin/create',
      data
    });
  }
};
